/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_DELETEVIDEOTAG,DELETEVIDEOTAG_RECEIVED } = constants.DeleteVideoTagConstant;

export default {
    REQUEST_DELETEVIDEOTAG,
    DELETEVIDEOTAG_RECEIVED,

  requestDeleteVideoTag: payload => ({
    type: REQUEST_DELETEVIDEOTAG,
    payload
  }),
  DeleteVideoTagReceived: () => ({
    type: DELETEVIDEOTAG_RECEIVED
  }),
};
